<template>
  <div>
    <h2 style="margin-bottom: 16px;">招聘中心</h2>
    <el-tabs type="border-card">
      <!-- 公司信息 -->
      <el-tab-pane label="公司信息">
        <el-form :model="form" label-width="100px" style="max-width: 720px;">
          <el-form-item label="公司名称">
            <el-input v-model="form.company_name" disabled placeholder="公司名称需通过认证后确定"></el-input>
          </el-form-item>
          <el-form-item label="公司规模">
            <el-input v-model="form.company_scale" placeholder="如：50-100人"></el-input>
          </el-form-item>
          <el-form-item label="投递方式">
            <el-input v-model="form.company_mail" placeholder="简历投递邮箱"></el-input>
          </el-form-item>
          <el-form-item label="公司简介">
            <rich-editor v-model="form.company_content"></rich-editor>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="savecompany">确定</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 岗位管理 -->
      <el-tab-pane label="岗位管理">
        <el-button type="text" icon="el-icon-plus" style="margin-bottom: 12px;" @click="dialogVisible = true">添加工作信息</el-button>
        <el-table :data="joblist" border>
          <el-table-column label="日期" width="170">
            <template slot-scope="scope">{{ scope.row.job_createtime | dataFormat }}</template>
          </el-table-column>
          <el-table-column label="名称" prop="job_name"></el-table-column>
          <el-table-column label="类型" prop="job_lable" width="100"></el-table-column>
          <el-table-column label="薪资" prop="job_salary" width="120"></el-table-column>
          <el-table-column label="招聘人数" prop="job_num" width="100"></el-table-column>
          <el-table-column label="操作" width="160" fixed="right">
            <template slot-scope="scope">
              <a :href="`${url}/#/jobcontent/${scope.row.job_id}`" target="_blank" style="color: #0E7490; font-size: 13px; margin-right: 10px;">查看</a>
              <el-button type="text" style="color: #f56c6c;" @click="deletejob(scope.row.job_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <!-- 岗位弹窗 -->
    <el-dialog title="编辑岗位" :visible.sync="dialogVisible" width="70%">
      <div style="height: 400px; overflow: auto;">
        <el-form :model="job" label-width="100px">
          <el-form-item label="岗位名称">
            <el-input v-model="job.job_name"></el-input>
          </el-form-item>
          <el-form-item label="薪资">
            <el-input v-model="job.job_salary" placeholder="如：100元/天"></el-input>
          </el-form-item>
          <el-form-item label="人数">
            <el-input v-model="job.job_num"></el-input>
          </el-form-item>
          <el-form-item label="分类">
            <el-radio-group v-model="job.job_lable">
              <el-radio v-for="item in lable" :key="item" :label="item">{{ item }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="岗位简介">
            <rich-editor v-model="job.job_content"></rich-editor>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="createjob">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import richEditor from '@/components/editor.vue'
import { getWebCompany, changeWebCompany, createJob, deleteJob, getLable } from '@/api'

export default {
  name: 'CompanyManage',
  components: { richEditor },
  data() {
    return {
      form: { company_name: '', company_scale: '', company_mail: '', company_content: '' },
      joblist: [],
      lable: [],
      dialogVisible: false,
      job: { job_name: '', job_salary: '', job_num: '', job_lable: '', job_content: '' }
    }
  },
  computed: {
    ...mapState({ url: (s) => s.url })
  },
  created() {
    getLable('招聘分类').then((res) => {
      this.lable = JSON.parse(res.data[0].lable) || []
    })
    getWebCompany().then((res) => {
      const d = res.data || {}
      if (d.company) {
        this.form = { company_name: d.company.company_name, company_scale: d.company.company_scale, company_mail: d.company.company_mail, company_content: d.company.company_content }
        this.job.company_id = d.company.company_id
      }
      this.joblist = d.joblist || []
    })
  },
  methods: {
    savecompany() {
      changeWebCompany(this.form).then(() => {
        this.$message.success('公司信息保存成功')
      })
    },
    createjob() {
      if (!this.job.job_name) {
        this.$message.error('请填写岗位名称')
        return
      }
      createJob(this.job).then(() => {
        this.$message.success('岗位发布成功')
        this.dialogVisible = false
        this.job = { job_name: '', job_salary: '', job_num: '', job_lable: '', job_content: '' }
        getWebCompany().then((res) => {
          this.joblist = (res.data && res.data.joblist) || []
        })
      })
    },
    deletejob(id) {
      this.$confirm('确定删除该岗位吗？', '提示', { type: 'warning' }).then(() => {
        deleteJob(id).then(() => {
          this.$message.success('删除成功')
          getWebCompany().then((res) => {
            this.joblist = (res.data && res.data.joblist) || []
          })
        })
      }).catch(() => {})
    }
  }
}
</script>
